import moment from 'moment';

/**
 * @param {Object} transaction Transaction
 * @param {Object} hasArrow Indicates it has arrow
 * @returns {string}
 */
function formatSingleTransactionShield(transaction, hasArrow) {
  const arrowIcon = `
    <div class="transaction-arrow">
      <svg viewBox="0 0 136 143" xmlns="http://www.w3.org/2000/svg">
        <path d="M75.504 89.42h-62.1c-8.1 0-12.5-4.2-12.5-12.2v-11.2c.2-7.3 4.6-11.7 12-11.7h63c-1-1.2-1.7-1.7-2.4-2.7l-23.4-23.4c-6.1-6.1-6.1-12.5 0-18.3l5.9-5.9c5.1-4.9 11.5-4.9 16.6-.2.7.7 1.7 1.7 2.7 2.4l55.2 55.2c7.1 7.1 7.1 13.2 0 20l-56.2 56.2c-6.6 6.6-12.7 6.6-19.5 0l-5.1-5.1c-4.9-5.1-4.9-11.7 0-16.9l23.7-23.7c.7-.7 1.7-1.2 2.7-2-.3.2-.3-.1-.6-.5z" fill="currentColor"/>
      </svg>
    </div>
`;

  const hasArrowIcon = hasArrow ? arrowIcon : '';

  return `
    <div class="single-team-container">
      ${hasArrowIcon}
      <div class="transaction-team team-${hasArrow ? '2' : '1'}" data-team-name="${transaction.clube_projeto.nome}">
        <img class="escudo" src=${transaction.clube_projeto.escudo} />
        <div class="team-initials">${transaction.clube_projeto.sigla}</div>
      </div>
    </div>
  `;
}

/**
 * @param {Object} transactions Transaction
 * @param {Object} hasArrow Indicates it has arrow
 * @returns {string}
 */
export function formatTransactionsShields(transactions, hasArrow = false) {
  if (transactions && transactions.length) {
    return transactions.map(transaction => formatSingleTransactionShield(transaction, hasArrow)).join('');
  } else if (hasArrow && !transactions.length) {
    return `
      <div class="single-team-container">
        <div class="transaction-arrow">
          <svg viewBox="0 0 136 143" xmlns="http://www.w3.org/2000/svg">
            <path d="M75.504 89.42h-62.1c-8.1 0-12.5-4.2-12.5-12.2v-11.2c.2-7.3 4.6-11.7 12-11.7h63c-1-1.2-1.7-1.7-2.4-2.7l-23.4-23.4c-6.1-6.1-6.1-12.5 0-18.3l5.9-5.9c5.1-4.9 11.5-4.9 16.6-.2.7.7 1.7 1.7 2.7 2.4l55.2 55.2c7.1 7.1 7.1 13.2 0 20l-56.2 56.2c-6.6 6.6-12.7 6.6-19.5 0l-5.1-5.1c-4.9-5.1-4.9-11.7 0-16.9l23.7-23.7c.7-.7 1.7-1.2 2.7-2-.3.2-.3-.1-.6-.5z" fill="currentColor"/>
          </svg>
        </div>
        <div class="empty-shield">
          <svg viewBox="0 0 248.6 257.9" xmlns="http://www.w3.org/2000/svg">
            <path d="M124.5 24.3L226 57.2c0 129.3-101.5 178.2-101.5 178.2S23 186.5 23 57.2l101.5-32.9m0-13.6c-1.4 0-2.7.3-4.1.7L19 44.3c-5.4 1.7-9.5 7.1-9.5 12.9 0 70.9 29.5 119.1 54.3 146.6 26.8 30.2 54 43.1 55 43.8 1.7 1 3.7 1.4 5.8 1.4s4.1-.3 5.8-1.4c1-.7 28.2-13.6 55-43.8 24.8-27.5 54.3-75.7 54.3-146.6 0-5.8-3.7-11.2-9.5-12.9L128.6 11.4c-1.4-.7-2.7-.7-4.1-.7z" fill="currentColor"/>
          </svg>
        </div>
      </div>
    `;
  }

  return `
    <div class="single-team-container">
      <div class="empty-shield">
        <svg viewBox="0 0 248.6 257.9" xmlns="http://www.w3.org/2000/svg">
          <path d="M124.5 24.3L226 57.2c0 129.3-101.5 178.2-101.5 178.2S23 186.5 23 57.2l101.5-32.9m0-13.6c-1.4 0-2.7.3-4.1.7L19 44.3c-5.4 1.7-9.5 7.1-9.5 12.9 0 70.9 29.5 119.1 54.3 146.6 26.8 30.2 54 43.1 55 43.8 1.7 1 3.7 1.4 5.8 1.4s4.1-.3 5.8-1.4c1-.7 28.2-13.6 55-43.8 24.8-27.5 54.3-75.7 54.3-146.6 0-5.8-3.7-11.2-9.5-12.9L128.6 11.4c-1.4-.7-2.7-.7-4.1-.7z" fill="currentColor"/>
        </svg>
      </div>
    </div>
  `;
}

/**
 * @param {Array} transactions Transaction
 * @returns {String}
 */
export default function formatUserFeedback(transactions) {
  const likeIcon = `
    <svg viewBox="0 0 15 17" xmlns="http://www.w3.org/2000/svg">
      <g fill="currentColor">
        <path d="M3.48 5.903s1.2-.2 3-2c1.7-1.7 2.8-3.2 3.7-3.2.9 0 1.2 3.1-1.4 5.2 1.4-.2 4.7-.7 5.2.5.8 1.8.1 8.1-1.6 9.5-1.4 1.1-5.9.8-6.8.5-.4-.1-2.1-1-2.1-1v-9.5zM1.38 5.903h1v10h-1c-.6 0-1-.5-1-1v-7.9c0-.6.5-1.1 1-1.1z"/>
      </g>
    </svg>
  `;

  const dislikeIcon = `
    <svg viewBox="0 0 14 16" xmlns="http://www.w3.org/2000/svg">
      <g fill="currentColor">
        <path d="M10.9 10.8s-1.2.2-3 2C6.2 14.5 5.1 16 4.2 16c-.9 0-1.2-3.1 1.4-5.2-1.4.2-4.7.7-5.2-.5C-.4 8.5.3 2.2 2 .8 3.4-.3 7.9 0 8.8.3c.4.1 2.1 1 2.1 1v9.5zM13 10.8h-1V.8h1c.6 0 1 .5 1 1v7.9c0 .6-.5 1.1-1 1.1z"/>
      </g>
    </svg>
  `;

  if (Array.isArray(transactions)) {
    return transactions.map((transaction) => {
      const { enquete } = transaction;
      const positiveFeedback = enquete.respostas.filter(resposta => resposta.nome === 'sim')[0];
      const negativeFeedback = enquete.respostas.filter(resposta => resposta.nome === 'nao')[0];

      return `
        <div class="user-feedback" data-enquete="${enquete.id}">
          <div class="single-feedback feedback-positive" data-resposta="${positiveFeedback.id}" data-feedback="positive">
            <div class="feedback-icon">${likeIcon}</div>
            <div class="feedback-number">${positiveFeedback.percentual}%</div>
          </div>
          <div class="single-feedback feedback-negative" data-resposta="${negativeFeedback.id}" data-feedback="negative">
            <div class="feedback-icon">${dislikeIcon}</div>
            <div class="feedback-number">${negativeFeedback.percentual}%</div>
          </div>
          <div class="vote-success-feedback">Obrigado pelo voto!</div>
        </div>
      `;
    }).join('');
  }

  const { enquete } = transactions;
  const positiveFeedback = enquete.respostas.filter(resposta => resposta.nome === 'sim')[0];
  const negativeFeedback = enquete.respostas.filter(resposta => resposta.nome === 'nao')[0];

  return `
    <div class="user-feedback" data-enquete="${enquete.id}">
      <div class="single-feedback feedback-positive" data-resposta="${positiveFeedback.id}" data-feedback="positive">
        <div class="feedback-icon">${likeIcon}</div>
        <div class="feedback-number">${positiveFeedback.percentual}%</div>
      </div>
      <div class="single-feedback feedback-negative" data-resposta="${negativeFeedback.id}" data-feedback="negative">
        <div class="feedback-icon">${dislikeIcon}</div>
        <div class="feedback-number">${negativeFeedback.percentual}%</div>
      </div>
      <div class="vote-success-feedback">Obrigado pelo voto!</div>
    </div>
  `;
}

/**
 * @param {Object} chegando transactions
 * @param {Object} saindo transactions
 * @returns {String}
 */
export function checkIfIsNew(chegando, saindo) {
  let isNew = false; // eslint-disable-line
  saindo.forEach((transaction) => {
    if (moment().diff(moment(transaction.data_ultima_atualizacao), 'days') <= 0) {
      isNew = true;
    }
  });

  chegando.forEach((transaction) => {
    if (moment().diff(moment(transaction.data_ultima_atualizacao), 'days') <= 0) {
      isNew = true;
    }
  });

  if (isNew) {
    return '<span class="player-is-new">novo</span>';
  }
  return '';
}



// WEBPACK FOOTER //
// local_static/templates/vai_vem/2018/assets/scripts/components/commonTransactions.js